import React from 'react';
import { ModalProvider } from 'react-modal-hook';
import { Outlet } from 'react-router-dom';
import PageTracker from 'Components/PageTracker';
import ScrollToTop from 'Components/ScrollToPop';
import { WrapperProps } from 'Interfaces/Common';

const RootWrapper = ({ children }: WrapperProps) => (
  <ModalProvider>
    <PageTracker />
    <ScrollToTop />
    {children ?? <Outlet />}
  </ModalProvider>
);

export default RootWrapper;
